import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getReceivedInvitations } from '../api/settingsApi';
import { InvitationDto } from '../types/settings';
import { useUser } from '../contexts/UserContext';

export const useReceivedInvitations = () => {
  const { currentUser } = useUser();
  const queryClient = useQueryClient();

  const query = useQuery<InvitationDto[]>({
    queryKey: ['receivedInvitations', currentUser?.email],
    queryFn: getReceivedInvitations,
    enabled: !!currentUser?.email,
    staleTime: 1000 * 60 * 5, // 5 minutes
    // Removed refetchInterval - now using SignalR for real-time updates
  });

  const invalidateInvitations = () => {
    queryClient.invalidateQueries({ queryKey: ['receivedInvitations', currentUser?.email] });
  };

  return {
    ...query,
    invitations: query.data || [],
    invalidateInvitations,
  };
};
